import { useSetAtom } from 'jotai';

import * as state from '../../../_state/brokeredLoadDetail.state';

import { FileMutations } from '~/shared/types/file';

export const useBrokeredLoadFiles = (): FileMutations => {
  const createFile = useSetAtom(state.$createBrokeredLoadFile);
  const confirmFileUpload = useSetAtom(state.$confirmBrokeredLoadFileUpload);
  const deleteFile = useSetAtom(state.$deleteBrokeredLoadFile);

  return {
    createFile: async (params) => {
      const result = await createFile({
        loadId: params.entityId,
        fileName: params.fileName,
        fileSize: params.fileSize,
        mimeType: params.mimeType,
      });

      return {
        id: result.tradeLoadPhotoCreate.file.id,
        uploadUrl: result.tradeLoadPhotoCreate.uploadUrl ?? '',
      };
    },
    confirmUpload: async (params) => {
      await confirmFileUpload({ fileId: params.fileId });

      return {
        url: '',
      };
    },
    deleteFile: async (params) => {
      await deleteFile({ fileId: params.fileId });
    },
  };
};
